<div class="parent"
     *ngIf="show"
     [style.left.px]="posLeft"
     [style.top.px]="posTop"
     [style.width.px]="posWidth">
  <div class="waiting"
       *ngIf="isSearching">
    <i class="fa fa-circle-o-notch fa-spin fa-fw fa-lg"></i>
  </div>
  <div class="list"
       *ngIf="!isSearching">
    <div class="empty"
         *ngIf="(!cubSearchResults || cubSearchResults.length === 0) && categories.length === 0 && !loadingCategories">
      No quick results.
    </div>

    <!-- Top CUB hits -->
    <div class="section-heading"
         *ngIf="cubSearchResults && cubSearchResults.length > 0">CUB</div>
    <div class="cub-list"
         *ngIf="cubSearchResults && cubSearchResults.length > 0">
      <div class="cub-row"
           *ngFor="let result of cubSearchResults | slice:0:5; let i = index"
           [class.row-selected]="selectedIndex === i"
           (click)="itemClick(result)">
        <span class="cub-icon">
          <i class="fa {{ result.icon }}"></i>
        </span>
        <span class="cub-text">
          <span class="cub-name">{{ result.description }}</span>
          <span class="cub-type">{{ result.type }}</span>
        </span>
      </div>
    </div>

    <!-- File-source category summary rows -->
    <div class="categories"
         *ngIf="categories.length > 0 || loadingCategories">
      <div class="section-heading">Other System Results</div>
      <div class="category-row"
           *ngFor="let cat of categories; let ci = index"
           [class.row-selected]="selectedIndex === navCubResults.length + ci"
           (click)="categoryClick(cat)">
        <span class="cat-badge badge-{{ cat.colorKey }}">
          <img [src]="cat.img"
               class="cat-img"
               alt="" />
        </span>
        <span class="cat-label">{{ cat.label }}</span>
        <span class="cat-count">{{ cat.count }}</span>
      </div>
      <div class="cat-loading"
           *ngIf="loadingCategories">
        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Searching files&hellip;
      </div>
    </div>
  </div>
  <div class="controls">
    <button mat-raised-button
            color="primary"
            [class.btn-selected]="selectedIndex === searchMoreIndex"
            (click)="navigateToSearch()">Search More...</button>
  </div>
</div>
